import { Close,FactCheckRounded } from '@mui/icons-material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';

function ShowStockClose() {
const [lasttwomonth,setLastTwoMonths]=useState([]);
    const [manualdate,setManualdate]=useState('');
    const [tilldate,setTillDate]=useState('');
    const [results,setresults]=useState([]);
    const [isloading,setisloading]=useState(false);

useEffect(()=>{

  axios.get('api/get/dailyclosessales').then(res=>{
    //console.log(res.data);
if(res.data.status==='success'){

setTillDate(res.data.data.maxDate);
setLastTwoMonths(res.data.data.lasttwomonth);
setManualdate(res.data.data.lasttwomonth[0].manual_date);


}


  })


},[])



        const handleTillDate=(e)=>{
            e.preventDefault();
            setTillDate(e.target.value);
            
            }
            const handleSubmit=()=>{


                setisloading(true);


                if(manualdate===tilldate||manualdate>tilldate){
                  Swal.fire({
                      position: 'top-end',
                      icon: 'warning',
                      title: "closing date should be less than selling date",
                      showConfirmButton: false,
                      timer: 1500
                    })
                    setisloading(false);
              
                  return false;
              }

const data={
'manual_date':manualdate,
'tillDate':tilldate

}

axios.get('/sanctum/csrf-cookie').then(res=>{
    axios.post('api/showstockdayclose',data).then(res=>{
   
    if(res.data.results.length>0){
      
        setresults(res.data.results);

    }else{
  Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: "No Closing Stock Saved!",
              showConfirmButton: false,
              timer: 1500
            })
    }
    setisloading(false);
 
    })
    
    })


            }
        

  return (
    <div className='row mt-2'>
       
      <div className='col-md-5 col-sm-5'>
      
        <h5 style={{color:'green',marginLeft:'4px'}} className='mb-2'>Closing Stock Date</h5>
<select value={manualdate} style={{padding:'6px',width:'100%',marginLeft:'4px'}}  onChange={(e)=>setManualdate(e.target.value)}>
  {lasttwomonth.map((item,index)=>(
  <option key={index} value={item.manual_date}>{item.manual_date}</option>

  ))}
</select>
  
</div>
<div className='col-md-5 col-sm-5'>
<h5 style={{color:'green'}} className='mb-2'>Last Sale Date</h5>

<input type="date" className='form-control' readOnly  value={tilldate} name='tilldate' onChange={handleTillDate}></input>
</div>
<div className='col-md-2 col-sm-2 mt-4'>
    
<button className='btn btn-primary' onClick={handleSubmit}  disabled={isloading} >
Fetch Record
</button>
</div>

<div className='col-12 mt-4'>
  <div style={{display:'flex',justifyContent:'space-between'}}>
    <p style={{backgroundColor:'blue',color:'white'}}>

    Blue means some items are newly added 

    </p>
  

<p style={{backgroundColor:'green',color:'white'}}>

Green means everything perfect

</p>

<p style={{backgroundColor:'red',color:'white'}}>

If Red then contact with admin

</p>



  </div>
<table>
    <thead>
        <tr>
        <th>Sr</th>
        <th>Name</th>
        <th>Closing First</th>
        <th>Closing Second</th>
        <th>Returned</th>
        <th>Purchased </th>
        <th>Sold</th>
        <th>Stock Difference</th>
       
       
        
        </tr>
    </thead>

    <tbody>

    {results.map((row, index) => (
         <tr key={index} style={(row.closing_stock_last_date  ===row.closing_stock_first_date+ row.purchased_between_dates - row.sold_between_dates+row.returned_between_dates) ? { backgroundColor: 'green',color:'white' }: (row.closing_stock_first_date===0)?{backgroundColor:'blue'}: {backgroundColor:'red'}}>

       
        
            <td>{++index}</td>
            <td>{row.product_name}</td>
            <td>{row.closing_stock_first_date===0? Number(row.closing_stock_last_date)+Number(row.sold_between_dates):row.closing_stock_first_date}</td>
            <td>{row.closing_stock_last_date}</td>
            <td style={(row.returned_between_dates)>1?{color:'yellow',fontSize:15}:{color:'white'}}>{row.returned_between_dates}</td>
            <td>{row.purchased_between_dates}</td>
            <td style={(row.sold_between_dates>1)?{color:'yellow'}:{color:'white'}}>{row.sold_between_dates}</td>
            <td>{(row.closing_stock_last_date  ===row.closing_stock_first_date+ row.purchased_between_dates - row.sold_between_dates+row.returned_between_dates)?<FactCheckRounded style={{color:'yellow'}}></FactCheckRounded>:<Close style={{color:'green'}}/>}</td>
         
           
          
          </tr>
        ))}
    </tbody>
</table>
</div>
    </div>
  )
}

export default ShowStockClose

